<template>
  <div class="app-container">
    <div class="index-tree-box">
      <el-drawer direction="ltr" size="250px" :visible.sync="show" :with-header="false">
        <div class="left-box" style="height: 100%;">
          <dp-tree
            ref="dpTreeMb"
            is-drawer
            @title-click="onSelectAll"
            @on-select="onSelect"
            @on-edit="onEdit"
          />
        </div>
      </el-drawer>
    </div>
    <list ref="list" style="overflow: auto;" :class="{'right-box':all&&!isMB}">
      <div slot="toolbar-left" style="display: inline-block;margin-right: 5px;">
        <el-button v-if="all" type="primary" @click="onShow">组织架构</el-button>
      </div>
      <template slot="toolbar-right">
        <template v-if="$permission.canWrite()&&all">
          <el-button type="primary" plain @click="openDefault">默认标签</el-button>
          <el-button type="primary" plain @click="openTags">打标签</el-button>
        </template>
        <el-button type="primary" plain @click="exportTeacher" v-if="!isMB&&$permission.can('导出')">导出</el-button>
        <template v-if="$permission.canWrite()">
          <template v-if="!isMB">
            <el-button type="success" plain @click="importTeacher" v-if="base&&all">导入</el-button>
            <el-button type="success" plain @click="importCheck" v-if="check">导入考核</el-button>
            <el-button type="success" plain @click="importJob" v-if="job">导入职务</el-button>
          </template>
          <el-button type="primary" @click="create" v-if="all" icon="el-icon-plus">添加</el-button>
          <el-button type="danger" @click="delRows" v-if="all">删除</el-button>
        </template>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="170px">
          <template slot-scope="{row}">
            <el-button type="text" v-if="all" @click="setMsg(row)">管理班级</el-button>
            <el-button type="text" v-if="all" @click="setDorm(row)">管理宿舍</el-button>
            <el-button type="text" @click="editById(row.TeacherId)">编辑</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-check-dialog ref="importCheckDialog" @upload-success="reload" />
    <import-job-dialog ref="importJobDialog" @upload-success="reload" />
    <msg-dialog ref="msgDialog" @close-saved="reload" />
    <set-dorm-dialog ref="setDormDialog" @close-saved="reload" />
    <default-dialog ref="defaultDialog" />
    <tag-dialog ref="tagDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fa/teacher/list";
import editDialog from "@/components/fa/teacher/editDialog";
import importDialog from "@/components/fa/teacher/importDialog";
import importCheckDialog from "@/components/fa/teacher/importCheckDialog";
import importJobDialog from "@/components/fa/teacher/importJobDialog";
import msgDialog from "@/components/fa/teacher/msgDialog";
import setDormDialog from "@/components/fa/teacher/setDormDialog";
import dpTree from "@/components/fa/teacher/tree/index";
import defaultDialog from "@/components/fa/teacher/defaultDialog";
import tagDialog from "@/components/fa/teacher/tagDialog";

export default {
  name: "teacher",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    importCheckDialog,
    importJobDialog,
    msgDialog,
    setDormDialog,
    dpTree,
    defaultDialog,
    tagDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      FuncCodes: "",
      show: false,
    };
  },
  computed: {
    base() {
      return this.FuncCodes.indexOf("Base") != -1 || false; //基本信息
    },
    check() {
      return this.FuncCodes.indexOf("Check") != -1 || false; //年度考核情况
    },
    job() {
      return this.FuncCodes.indexOf("Job") != -1 || false; //职务变动情况
    },
    all() {
      return this.FuncCodes.indexOf("All") != -1 || false; //全部数据
    },
  },
  mounted() {
    var permission = this.$store.state.sys.permissionMenus;
    var menus = permission.find((x) => x.FullPath == "/fa/teacher");
    this.FuncCodes = menus.FuncCodes;
    // if (!this.isMB) this.$refs.dpTree.getData();
  },
  methods: {
    onShow() {
      this.show = true;
      this.$nextTick(() => {
        // console.log(this.$refs.dpTreeMb);
        this.$refs.dpTreeMb.getData();
      });
    },
    importTeacher() {
      this.$refs.importDialog.open();
    },
    importCheck() {
      this.$refs.importCheckDialog.open();
    },
    importJob() {
      this.$refs.importJobDialog.open();
    },
    exportTeacher() {
      console.log("exportTeacher");
      this.$refs.list.export();
    },
    openDefault() {
      this.$refs.defaultDialog.open();
    },
    openTags() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要打标签的数据");
        return;
      }
      let ids = rows.map((item) => item.TeacherId);
      this.$refs.tagDialog.openCreate({ Ids: ids });
    },
    setMsg(row) {
      this.$refs.msgDialog.open(row);
    },
    setDorm(row) {
      this.$refs.setDormDialog.openEditById(row.TeacherId);
    },
    onEdit(data) {
      console.log("编辑");
      // this.api.info(data.QueryPlanId).then((res) => {
      //   this.$emit("on-edit", res.Data);
      // });
    },
    onSelect(data) {
      console.log("选择", data);
      this.$refs.list.getData({ DpIdChain: data.IdChain });
    },
    onSelectAll() {
      this.$refs.list.getData({});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.TeacherId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>